import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

// Utils
import { jsonEmptyContentState } from 'Shared/utils/draftJsHelpers';

// Actions
import { addItem } from 'Shared/actions/todos';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

export const useAddMeetingItem = () => {
  const dispatch = useDispatch();

  const [isCreatingMeetingItem, toggleIsCreatingMeetingItem] = useToggle(false);

  const handleAddMeetingItem = useCallback(
    ({
      workspaceId,
      jsonBody,
      isSuggestedTopic = false,
      asanaData = null,
      servicenowData = null,
      assignmentInfo,
      isAssignCurrentUser,
      isSection = false,
      position = 1,
      itemType,
    } = {}) => {
      const body = jsonBody || jsonEmptyContentState();
      const itemUuid = uuidv4();
      return dispatch(
        addItem({
          itemUuid,
          isSuggestedTopic,
          isSection,
          body,
          workspaceId,
          position,
          itemType,
          asanaData,
          servicenowData,
          assignmentInfo,
          isAssignCurrentUser,
        })
      ).then(response => {
        toggleIsCreatingMeetingItem();
        return response;
      });
    },
    [dispatch, toggleIsCreatingMeetingItem]
  );

  return { isCreatingMeetingItem, handleAddMeetingItem };
};
